import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

declare global {
  interface Window { __APP_VERSION__?: string }
}

declare const __APP_VERSION__: string | undefined;

// Versione corrente del bundle
const BUNDLE_VERSION = window.__APP_VERSION__ ?? 
                       (typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : undefined) ??
                       null;

// Funzione per controllare la versione e forzare reload se necessario
async function checkVersionAndReload(): Promise<boolean> {
  // Se non siamo in produzione, non fare nulla
  if (!import.meta.env.PROD) {
    return false;
  }

  try {
    // Forza fetch senza cache usando timestamp
    const cacheBuster = `?t=${Date.now()}`;
    const res = await fetch(`/version.txt${cacheBuster}`, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });

    if (!res.ok) {
      return false;
    }

    const serverVersion = (await res.text()).trim();
    if (!serverVersion) {
      return false;
    }

    // Versione salvata nel localStorage
    const savedVersion = localStorage.getItem('app_version');

    // Se non abbiamo una versione salvata, salva quella del server e continua
    if (!savedVersion) {
      localStorage.setItem('app_version', serverVersion);
      if (BUNDLE_VERSION) {
        localStorage.setItem('bundle_version', BUNDLE_VERSION);
      }
      return false;
    }

    // Se la versione del server è diversa da quella salvata, FORZA RELOAD IMMEDIATO
    if (serverVersion !== savedVersion) {
      localStorage.setItem('app_version', serverVersion);
      // Forza hard reload con cache bypass
      window.location.href = window.location.href.split('?')[0] + '?v=' + Date.now();
      return true; // Indica che stiamo ricaricando
    }

    // Se la versione del bundle è diversa da quella salvata, anche qui ricarica
    if (BUNDLE_VERSION && localStorage.getItem('bundle_version') !== BUNDLE_VERSION) {
      localStorage.setItem('bundle_version', BUNDLE_VERSION);
      localStorage.setItem('app_version', serverVersion);
      window.location.href = window.location.href.split('?')[0] + '?v=' + Date.now();
      return true;
    }

    return false;
  } catch (error) {
    // In caso di errore, continua comunque
    return false;
  }
}

// Controlla la versione PRIMA di renderizzare qualsiasi cosa
async function initApp() {
  const isReloading = await checkVersionAndReload();
  
  if (isReloading) {
    // Stiamo ricaricando, non renderizzare nulla
    return;
  }

  // Tutto OK, procedi con il rendering
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Dopo il rendering, continua a monitorare la versione (per deploy futuri)
  if (import.meta.env.PROD) {
    // Check ogni 30 secondi (più frequente)
    setInterval(async () => {
      await checkVersionAndReload();
    }, 30000);
  }
}

// Avvia l'app
initApp();
